import React from "react";
import styled from "styled-components";
import { LayoutGrid, List } from "lucide-react";
import { NEW_LOOK_ICON_STROKE } from "common/NewLook/layout.ts";

interface NewLookLayoutSwitchProps {
  isCardsView: boolean;
  onClick: () => void;
}

/** Table / cards toggle: a quiet segmented control with lucide icons. */
const NewLookLayoutSwitch = ({
  isCardsView,
  onClick,
}: NewLookLayoutSwitchProps) => (
  <Wrapper>
    {[false, true].map((cards) => {
      const Icon = cards ? LayoutGrid : List;
      return (
        <Option
          key={String(cards)}
          type="button"
          $selected={isCardsView === cards}
          aria-pressed={isCardsView === cards}
          onClick={onClick}
        >
          <Icon size={16} strokeWidth={NEW_LOOK_ICON_STROKE} />
        </Option>
      );
    })}
  </Wrapper>
);

export default React.memo(NewLookLayoutSwitch);

const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  height: 32px;
  border-radius: ${(p) => p.theme.radii.control}px;
  background: ${(p) => p.theme.colors.cardLightBgColor};
  border: ${(p) => p.theme.borders.card};
`;
const Option = styled.button<{ $selected: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 24px;
  padding: 0;
  border: 0;
  border-radius: 7px;
  cursor: pointer;
  color: ${(p) =>
    p.$selected ? p.theme.colors.primaryBlue : p.theme.colors.secondaryText};
  background: ${(p) => (p.$selected ? p.theme.colors.cardBgColor : "none")};
  box-shadow: ${(p) =>
    p.$selected ? `0 1px 2px ${p.theme.colors.lightestBorderGrey}` : "none"};
  transition: color 0.15s, background 0.15s;
  &:hover {
    color: ${(p) => p.theme.colors.primaryBlue};
  }
`;
